import { createContext, useContext } from 'react';

export type EnvConfig = {
    thumbnailsPath: string
    thumbnailWidth: number
    thumbnailHeight: number
    modelsPath: string
    materialsPath: string
    environmentPath: string
}

export const EnvConfigContext = createContext<EnvConfig>({
    thumbnailsPath: '',
    thumbnailWidth: 0,
    thumbnailHeight: 0,
    modelsPath: '',
    materialsPath: '',
    environmentPath: ''
});

export const useEnvConfig = () => {
    return useContext(EnvConfigContext)
}
